// extracted by mini-css-extract-plugin
export var addToCartButton = "_sq-b";
export var arrowButtonContainer = "_sq-9";
export var arrowButtonIcon = "_sq-a";
export var carouselArrowButton = "_sq-6";
export var carouselElementContainer = "_sq-1";
export var galleryThumbnail = "_sq-d";
export var galleryThumbnailImage = "_sq-e";
export var left = "_sq-7";
export var productDisplayCarouselContainer = "_sq-0";
export var productTileContainer = "_sq-2";
export var productTileImage = "_sq-4";
export var productTileImageContainer = "_sq-3";
export var productTileTitle = "_sq-5";
export var right = "_sq-8";
export var sliderOverflow = "_sq-c";